import React, { useMemo } from 'react';
import PickupSessionGroupApi from '../PickupSessionGroupApi';
import PickupSessionGroupSettings from '../PickupSessionGroupSettings';
import DropMenu from '@dex/bubl-dash/src/lib/components/DropMenu/DropMenu';
import Link from '@dex/bubl-dash/src/lib/components/Link/Link';

const PickupSessionGroupActions: React.FC<any> = (props: any) => {

    const { data } = props;

    const del = PickupSessionGroupApi.delete(data.id, {
        onComplete: (response) => {

            if (data.modelName && data.id) {
                const event = new CustomEvent(data.modelName + data.id, { detail: 'deleted' });
                window.dispatchEvent(event);
            }

        }
    });

    return useMemo(() => {

        return (

            <DropMenu>

                <Link
                    path={`${ PickupSessionGroupSettings.path }/${data.id}/view`}
                >
                    View
                </Link>

                <Link
                    path={`${ PickupSessionGroupSettings.path }/${data.id}/edit`}
                >
                    Edit
                </Link>

                <Link
                    confirm={ {
                        title: `Delete ${ data[PickupSessionGroupSettings.primaryKey] }`,
                        message: "Are your sure you want to perform this action?"
                    } }
                    onClick={del.run}
                >
                    Delete
                </Link>

            </DropMenu>

        )

    }, [data, del]);

}

export default PickupSessionGroupActions;
